<template>
  <div class="bg-slightGrey width-100 min-height">
    <!-- 选择日期 -->
    <div class="train_time">
      <!--      <div v-if="!time_show" style="height: 328px; width: 100%; text-align: center">-->
      <!--        <van-loading size="24px" vertical style="margin-top: 150px">加载中...</van-loading>-->
      <!--      </div>-->
      <vue-hash-calendar
        :visible.sync="time_show"
        format="YY-MM-DD"
        :showTodayButton="false"
        :disabledWeekView="true"
        :disabled-date="disabledDate"
        :minDate="minDate"
        :maxDate="maxDate"
        pickerType="date"
        :defaultDatetime="time"
        @change="dateChange"
      >
        <template #action>
          <div class="flex-row justify-content-spaceBetween width-100">
            <div style="padding-top: 8px; line-height: 16px; font-size: 16px">{{ timeText }}</div>
            <div @click="toMyAppointed" style="padding: 6px 8px; border-radius: 5px; color: #ad3022; z-index: 1000">我的预约记录</div>
          </div>
        </template>
        <template #day="{ date, extendAttr }">
          <!--        {{ extendAttr.isDisabledDate ? '闭馆' : date.day }}-->
          <!--        {{ dateText(date, extendAttr) }}-->
          {{ date | dateFormat(extendAttr, venueDateMapReactive) }}
        </template>
      </vue-hash-calendar>
    </div>
    <!--    <trainTime @dateChange="dateChange"></trainTime>-->
    <div class="width-100 padding-90 flex-column justify-content-start align-items-center">
      <div class="width-100 margin-b br-mid bg-white padding-90">
        <p class="fs-big black margin-bs"><span class="circle"></span>选择时间段</p>
        <div class="width-100 flex-row justify-content-spaceBetween align-items-star flex-wrap">
          <van-button
            class="time-slot"
            :class="selectTimeSlotIndex === index ? 'selectTimeSlot' : ''"
            @click="handleTimeslotClick(item, index)"
            :disabled="item.remainSignNum < 1 || item.disabled"
            v-for="(item, index) in timeslotList"
            :key="index"
          >
            <p>{{ item.startTime + '-' + item.endTime }}</p>
            <p v-if="remainFlag">{{ ' (余' + item.remainSignNum + ')' }}</p>
          </van-button>
        </div>
      </div>
      <div class="width-100 margin-b br-mid">
        <div class="width-100 padding-90 bg-white flex-row justify-content-spaceBetween align-items-center bra-top">
          <p class="fs-big black"><span class="circle"></span>预约信息</p>
          <div class="width-50 switch-box position-relative flex-row justify-content-around align-items-center">
            <p class="zIndex" :class="form.signType === 1 ? 'red' : 'white'" @click="form.signType = 1">个人参观</p>
            <p class="zIndex" :class="form.signType === 2 ? 'red' : 'white'" @click="form.signType = 2">团队参观</p>
            <p class="select-bg position-absolute" :class="form.signType === 1 ? 'select1' : 'select2'"></p>
          </div>
        </div>

        <van-form @submit="handleSubmit">
          <div class="bra-bottom">
            <van-field
              v-if="form.signType === 2"
              v-model="form.signUnitName"
              name="团队名称"
              label="团队名称"
              placeholder="请输入团队名称"
              :rules="[{ required: true }]"
            />
            <van-field
              v-if="form.signType === 2"
              readonly
              clickable
              name="picker"
              :value="pickerValue"
              right-icon="arrow-down"
              label="团队所属地"
              placeholder="请选择团队所属地"
              @click="showPicker = true"
              :rules="[{ required: true }]"
            />
            <van-popup v-model="showPicker" round position="bottom">
              <van-cascader
                v-model="cascaderValue"
                title="请选择所在地区"
                :closeable="false"
                :options="orgList"
                @close="showPicker = false"
                @finish="onFinish"
              />
            </van-popup>
            <van-field
              v-model="form.signUsername"
              name="预约人姓名"
              label="预约人姓名"
              placeholder="请输入预约人姓名"
              :rules="[{ required: true }]"
            />
            <van-field
              v-model="form.signMobile"
              type="tel"
              name="联系号码"
              label="联系号码"
              placeholder="请输入联系号码"
              :rules="[{ required: true }, { pattern: /^1[3-9]\d{9}$/, message: '联系号码格式错误！' }]"
            />
            <van-field
              v-model="form.signIdnum"
              name="身份证号码"
              label="身份证号码"
              placeholder="请输入身份证号码"
              :rules="[
                { required: true },
                {
                  pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                  message: '身份证号格式错误！'
                }
              ]"
            />
            <van-field
              v-model="form.signNum"
              type="number"
              name="订票数量"
              label="订票数量"
              placeholder="请输入订票数量"
              :rules="[{ required: true }, { validator: signNumValidator, message: signNumText }]"
            />
            <van-field class="checkbox" name="checkbox" label="">
              <template #input>
                <van-checkbox v-model="form.childFlag" checked-color="rgb(182, 29, 21)" shape="square"
                  ><span class="darkgrey">携带小孩</span></van-checkbox
                >
              </template>
            </van-field>
          </div>

          <div class="width-100 textAlign-c" style="margin: 0 0 40px">
            <van-button
              type="primary"
              native-type="submit"
              class="width-50 button"
              color="linear-gradient(to bottom, rgb(182, 29, 21), rgb(194, 30, 21))"
              round
              >提交
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-undef,no-unused-vars */

import daysApi from '@/api/daysApi';
import orgApi from '@/api/orgApi';
import signApi from '@/api/signApi';
import wxApi from '@/api/wxApi';
import config from '@/config';
import moment from 'moment';
import { Notify } from 'vant';
export default {
  name: 'index',
  components: {},
  data() {
    return {
      // 场馆开放日期
      venueDateMap: new Map(),
      venueDateMapTrick: 0,
      // 最小选择时间
      minDate: null,
      // 最大选择时间
      maxDate: null,
      time_show: false,
      time: new Date(), //只接受中国标准时间
      timeText: null,
      // 预约表单
      form: {
        signType: 1,
        signDate: null,
        signTimeslotId: null,
        signUsername: null,
        signMobile: null,
        signIdnum: null,
        signNum: null,
        childFlag: false,
        signUnitName: null,
        signUnitArea: null,
        signUnitAddress: null,
        signUnitEmail: null,
        signIntroLetter: null,
        signAuthStatus: 0,
        createBy: 'front'
      },
      // 单位区域列表
      orgList: [],
      showPicker: false,
      pickerValue: null,
      cascaderValue: null,
      pickerFieldNames: {
        text: 'orgName',
        value: 'id',
        children: 'children'
      },
      selectTimeSlotIndex: -1,
      selectTimeSlot: {},
      // 时间段列表
      timeslotList: [],
      // 订票数validator 文本
      signNumText: '请控制订票数在' + config.SIGN_NUM_LIMIT.SINGLE_SIGN_MIN_NUM + '张到' + config.SIGN_NUM_LIMIT.SINGLE_SIGN_MAX_NUM + '张之间'
    };
  },
  computed: {
    venueDateMapReactive() {
      if (this.venueDateMapTrick !== undefined) {
        return this.venueDateMap;
      } else {
        return new Map();
      }
    },
    // 假期不显示余票
    // 每当假期时，需要控制这个假期的时间段内不显示余票，修改下方的日期
    remainFlag() {
      return !moment(this.time).isBetween('2026-09-30', '2026-10-08');
    }
  },
  mounted() {
    this.signPopup = true;
    const env = this.$store.state.env;
    console.log('current env', env);
    if (process.env.NODE_ENV === 'production') {
      if (env === 'raxw') {
        // 瑞安新闻登录
        this.form.signMobile = this.$store.state.raxwUser.mobile;
        this.form.wxId = 'raxw_' + this.$store.state.raxwUser.account_id;
      }
      if (env === 'wx') {
        // 微信已登录
        let openId = this.$store.state.openId;
        if (openId !== null && openId !== undefined) {
          this.form.wxId = this.$store.state.openId;
        } else {
          // 重新登陆
          this.$router.push('/login');
        }
      }
      if (env === undefined || env === null) {
        // 微信环境未登录，获取openid
        let code = this.$route.query.code;
        if (code !== null && code !== undefined) {
          wxApi.accessToken(code).then((res) => {
            if (res.msg !== null && res.code === 200) {
              let wxRes = JSON.parse(res.msg);
              if (wxRes.openid !== undefined) {
                // openid存入cookie
                this.$store.commit('SET_OPEN_ID', wxRes.openid);
                this.$store.commit('SET_ENV', 'wx');
                this.form.wxId = wxRes.openid;
              }
            }
          });
        } else {
          // 重新登陆
          this.$router.push('/login');
        }
      }
    } else {
      console.log('dev wxid', this.$store.state.openId);
      if (this.$store.state.openId !== null) {
        this.form.wxId = this.$store.state.openId;
      }
    }
    this.initTime();
    // 获取时间段数据
    this.mountedData();
  },
  watch: {
    'form.signType'(val) {
      this.form.signNum = null;
      this.initTime();
      if (val === 1) {
        // 个人
        // 1. 订票数控制
        this.signNumText =
          '请控制订票数在' + config.SIGN_NUM_LIMIT.SINGLE_SIGN_MIN_NUM + '张到' + config.SIGN_NUM_LIMIT.SINGLE_SIGN_MAX_NUM + '张之间';
        // 2. 预约起始offset时间控制
      } else {
        // 团队
        this.signNumText = '团体订票至少' + config.SIGN_NUM_LIMIT.TEAM_SIGN_NUM + '张起';
      }
    }
  },
  methods: {
    // 初始化vue-hash-calendar当前日期、最小选择日期和最大选择日期
    initTime() {
      this.time_show = false;
      this.time = moment()
        .add(this.form.signType === 1 ? 0 : config.SIGN_DATE_START_OFFSET, 'd')
        .toDate();
      let minDate = moment()
        .startOf('date')
        .add(this.form.signType === 1 ? 0 : config.SIGN_DATE_START_OFFSET, 'd');
      this.minDate = minDate.toDate();
      this.maxDate = minDate.add(config.SIGN_DATE_END_OFFSET, 'd').toDate();
      // 读取日期配置
      daysApi
        .openList({
          size: config.SIGN_DATE_END_OFFSET + 1
        })
        .then((res) => {
          res.data.forEach((day) => {
            if (day && day.daysDate && day.isOpen) {
              this.venueDateMap.set(day.daysDate, day.isOpen === '0');
            }
          });
          this.time_show = true;
          this.venueDateMapTrick = (this.venueDateMapTrick + 1) % 6;
        });
    },
    mountedData() {
      orgApi.pickerList(false).then((res) => {
        this.orgList = res.data;
      });
    },
    onConfirm(value) {
      this.form.signUnitArea = value;
      this.showPicker = false;
    },
    /**
     * 提交预约
     */
    handleSubmit() {
      console.log('submit');
      // 时间段非空判断
      if (this.selectTimeSlotIndex === -1) {
        Notify({
          type: 'warning',
          message: '请选择具体时间段'
        });
        return;
      }
      // 时间段是否过期判断
      let now = moment();
      if (moment(this.time + ' ' + this.timeslotList[this.selectTimeSlotIndex].endTime).isBefore(now)) {
        Notify({
          type: 'warning',
          message: this.time + ' ' + this.timeslotList[this.selectTimeSlotIndex].endTime + ' 已过当前时间，不可预约'
        });
        this.dateChange(this.time);
        return;
      }
      if (this.selectTimeSlotIndex === -1) {
        Notify({
          type: 'warning',
          message: '请选择具体时间段'
        });
        return;
      }
      // 时间段余票判断
      if (this.form.signNum > this.selectTimeSlot.remainSignNum) {
        Notify({
          type: 'warning',
          message: '当前时间段余票不足，请重新确认订票量'
        });
        return;
      }
      this.form.childFlag = this.form.childFlag ? 1 : 0;
      signApi.insert(this.form).then((res) => {
        if (res.code === 200) {
          Notify({
            type: 'success',
            message: '预约成功'
          });
          this.$router.push({
            path: '/myAppointed'
          });
        } else {
          Notify({
            type: 'warning',
            message: res.msg
          });
        }
      });
    },
    // 日期改变触发
    dateChange(date) {
      console.log('dateChange', date);
      this.time = moment(date).toDate(); //得到日期年月日
      this.form.signDate = date;
      // 读取当天时间段配置
      daysApi
        .listTimeslot({
          day: this.time
        })
        .then((res) => {
          // 假如当天为今天，则需要额外判断是否有时间段已过当前时间
          // let now = moment();
          // if (moment(date).isSame(now.format('yyyy-MM-DD'))) {
          //   // 是当天，判断时间段是否已过当前时间
          //   console.log(date, now, '是当天');
          //   res.data.forEach((item) => {
          //     if (moment(date + ' ' + item.endTime).isBefore(now)) {
          //       console.log(date + ' ' + item.endTime + ' 已过当前时间，不可预约');
          //       item.disabled = true;
          //     }
          //   });
          // }
          this.timeslotList = res.data;
          this.selectTimeSlotIndex = -1;
          this.selectTimeSlot = {};
        });
    },
    handleTimeslotClick(timeslot, index) {
      this.selectTimeSlotIndex = index;
      this.selectTimeSlot = timeslot;
      this.form.signTimeslotId = timeslot.id;
    },
    onFinish({ value, selectedOptions, tabIndex }) {
      console.log(value, selectedOptions, tabIndex);
      this.form.signUnitArea = value;
      this.pickerValue = selectedOptions[tabIndex].org.orgName;
      this.showPicker = false;
    },
    // 订票数validator
    signNumValidator(value) {
      return new Promise((resolve) => {
        if (this.form.signType === 1) {
          // 个人
          if (value < config.SIGN_NUM_LIMIT.SINGLE_SIGN_MIN_NUM || value > config.SIGN_NUM_LIMIT.SINGLE_SIGN_MAX_NUM) {
            resolve(false);
          } else {
            resolve(true);
          }
        } else {
          // 团队
          if (value < config.SIGN_NUM_LIMIT.TEAM_SIGN_NUM) {
            resolve(false);
          } else {
            resolve(true);
          }
        }
      });
    },
    toMyAppointed() {
      const env = this.$store.state.env;
      if (env === undefined || env === null) {
        Notify({
          type: 'warning',
          message: '微信信息获取中，请稍后'
        });
        return;
      }
      this.$router.push({
        path: '/myAppointed'
      });
    },
    // 禁用的日期
    disabledDate(date) {
      let day = moment(date).format('YYYY-MM-DD');
      return this.venueDateMap.get(day);
    }
  },
  filters: {
    // 日期文本格式化
    dateFormat: function (date, extendAttr, venueDateMap) {
      // 闭馆处理
      if (extendAttr.isDisabledDate) {
        if (
          venueDateMap.get(moment(date).format(date.year + '-' + (date.month + 1 + '').padStart(2, '0') + '-' + (date.day + '').padStart(2, '0')))
        ) {
          return '闭馆';
        }
      }
      // 常规处理
      if (date.day === 1) {
        return date.month + 1 + '月';
      } else {
        return date.day;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.train_time {
  background: #fff;
  padding: 0 10px;

  /deep/ .calendar_item {
    background: #fff !important;
  }
}

/deep/ .hash-calendar {
  --hash-calendar-bg-color: #ffffff;
}

/deep/ .calendar_day_checked {
  background: linear-gradient(to bottom, rgb(182, 29, 21), rgb(194, 30, 21));
  color: #ffffff !important;
  box-shadow: 0 5px 2px rgba(0, 0, 0, 0.05);
}

/deep/ .calendar_first_today {
  color: rgb(182, 29, 21);
}

///deep/ .calendar_item {
//  height: 42px !important;
//}

.circle {
  border-radius: 50%;
  border: 4px solid rgb(182, 29, 21);
  width: 14px;
  height: 14px;
  display: inline-block;
  margin-right: 10px;
}

.time-slot {
  width: 48%;
  margin-top: 10px;
  border-radius: 5px;
}

.selectTimeSlot {
  background: linear-gradient(to bottom, rgb(182, 29, 21), rgb(194, 30, 21));
  color: #ffffff;
}

/deep/ .van-button--disabled {
  background: #eeeeee;
}

.button {
  box-shadow: 0 5px 2px rgba(0, 0, 0, 0.05);
  margin-top: 40px;
}

.add-btn {
  width: 100%;
  border-radius: 10px;
  background: rgb(246, 246, 246);
  height: 4rem;
  color: #999999;
}

.switch-box {
  background: linear-gradient(to bottom, rgb(182, 29, 21), rgb(194, 30, 21));
  color: #ffffff;
  height: 26px;
  border-radius: 5px;

  .select-bg {
    height: 24px;
    width: 50%;
    top: 1px;
    background: #ffffff;
    border-radius: 5px;
    transition: 0.2s;
  }

  .select1 {
    left: 1px;
  }

  .select2 {
    left: 49.2%;
  }
}

.red {
  color: rgb(182, 29, 21);
}

.bra-top {
  border-radius: 10px 10px 0 0;
}

.bra-bottom {
  border-radius: 0 0 10px 10px;
  overflow: hidden;
  padding: 0 3% 10px;
  background: #ffffff;
}

/deep/ .van-cell::after {
  border-bottom: none;
}

/deep/ .van-cell {
  border: 1px solid #eeeeee;
  border-radius: 5px;
  margin-top: 10px;
}

.checkbox {
  border: none;
  padding: 0;
  margin-bottom: 40px;
}

/deep/ .van-uploader__input-wrapper {
  width: 100%;
}
</style>
